import { useFeatureFlag } from "@/shared/hooks/useFeatureFlag";

export const CO_APPROVAL_FLAG = "co-approval-workflow";

export function useCoApprovalEnabled(): boolean {
  return useFeatureFlag(CO_APPROVAL_FLAG);
}
